import { Injectable } from '@angular/core';

import { RepositoryService } from '@_services/api/repository.service';
import { GeneratedStepProgressFamilyApiService } from './step-progress-family-api-generated.service';

@Injectable({
  providedIn: 'root'
})
export class StepProgressFamilyApiService extends GeneratedStepProgressFamilyApiService {
  constructor(repo: RepositoryService) {
    super(repo);
  }
}
